'use client';

import { Fragment, useRef } from 'react';
import { GrClose } from 'react-icons/gr';
import SocialButtons from './social-buttons';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild,
} from '@headlessui/react';
import CopyButton from './copy-button';

export default function SharePopUp({ keyword, setIsOpen, isOpen }) {
  let shareUrl;

  if (typeof window !== 'undefined') {
    shareUrl = window.location.href;
  }

  const date = new Date();
  const options = { month: 'long', year: 'numeric' };
  const today = date.toLocaleDateString(undefined, options);

  const shareData = `CoherentMI\n${keyword} Size and Share Analysis - Growth Trends and Forecasts (2023 - 2030) Retrived On ${today} From,\n${shareUrl}`;

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-20" onClose={() => false}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center ">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className=" w-96 max-w-md  transform overflow-hidden rounded-2xl bg-gray-100 p-2 text-center align-middle shadow-xl transition-all">
                <div className="text-end">
                  <button
                    onClick={() => setIsOpen(false)}
                    className="btn border-0"
                  >
                    <GrClose size={25} />
                  </button>
                </div>
                <DialogTitle
                  as="h3"
                  className="text-lg font-semibold leading-6 text-gray-900 uppercase my-3"
                >
                  <SocialButtons
                    keyword={keyword}
                    shareData={shareData}
                    shareUrl={shareUrl}
                  />
                </DialogTitle>
                <div>
                  <CopyButton shareData={shareData} />
                </div>
                <div>
                  <textarea
                    name="shareData"
                    defaultValue={shareData}
                    rows={5}
                    disabled
                    className="w-full my-3 border rounded-lg overflow-scroll bg-white border-black "
                  ></textarea>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
